export const HideShowVariant = (xAxisChange: number, yAxisChange: number) => ({
  enter: (direction: number) => {
    return {
      x: direction > 0 ? xAxisChange : -xAxisChange,
      y: direction > 0 ? -yAxisChange : yAxisChange,
      opacity: 0,
    };
  },
  center: {
    x: 0,
    y: 0,
    opacity: 1,
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction > 0 ? -xAxisChange : xAxisChange,
      y: direction > 0 ? yAxisChange : -yAxisChange,
      opacity: 0,
    };
  },
});

export const getFadeInOutVariant = (opacity: number = 1) => ({
  enter: {
    opacity: 0,
  },
  center: {
    opacity,
  },
  exit: {
    opacity: 0,
  },
});
